import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import React, { useState, useEffect, useContext } from 'react'
import Logo from '../images/logo-circle.png'
import { Nav, Dropdown } from 'react-bootstrap'
import Login from './Login'
import axios from 'axios'
import Cookies from 'js-cookie'
import { AuthContext } from './AuthContext'

const HaNavbar = ({
  currentUser,
  setCurrentUser,
  loginShow,
  setLoginShow,
  redirectTo,
  setRedirectTo,
  sendDiscordNotification,
}) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { baseUrl } = useContext(AuthContext)
  const logOutUrl = '/api/crm/clinic/logout'

  const isLogin = (path) => {
    if (!currentUser) {
      setLoginShow(true)
      setRedirectTo(path)
    } else if (currentUser) {
      navigate('/')
    }
  }
  const handleLogout = (e) => {
    e.preventDefault()

    axios
      .get(baseUrl + logOutUrl, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: '*/*',
          session: currentUser.session,
        },
      })
      .then((res) => {
        // console.log('logout', res)
        Cookies.remove('session')
        setCurrentUser(null)
      })
      .catch((e) => {
        console.log('e', e)
      })
  }

  console.log('hanavbar loginShow', loginShow)

  return (
    <>
      <div className="d-flex flex-column haNav  align-items-center">
        <Link to="/">
          <div className="logoWrap mt-5">
            <img className="w-100" src={Logo} alt="ha-logo" />
          </div>
        </Link>

        <Nav className="navItemsGroup flex-column">
          {/* <h6>(Beta 版)</h6> */}
          <NavLink
            to="/"
            className={`nav-link ${
              pathname.startsWith('/currentNews') ? 'active' : ''
            }`}
          >
            <i className="fa-solid fa-house-medical me-2"></i>
            最新消息
          </NavLink>
          <NavLink
            to={currentUser ? '/patient-data' : ''}
            className={` ${pathname === '/patient-data' ? 'nav-link' : ''}`}
            onClick={() => {
              isLogin('/patient-data')
            }}
          >
            <i className="fa-solid fa-chart-line me-2"></i>
            用戶數據
          </NavLink>
          {/* <NavLink
            to={currentUser ? '/health-data' : ''}
            className={` ${pathname === '/health-data' ? 'nav-link' : ''}`}
            onClick={() => {
              isLogin('/health-data')
            }}
          >
            <i className="fa-solid fa-chart-line me-2"></i>
            健康數據
          </NavLink> */}
          {/* <Dropdown drop="end" className="userData">
            <Dropdown.Toggle
              size="lg"
              variant=""
              id="dropdown-basic"
              // style={{ color: '#4b4b4b', fontSize: '18px' }}
            >
              <i className="fa-solid fa-user-group me-2"></i>
              <span>用戶數據</span>
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ fontSize: '18px' }}>
              <Dropdown.Header>專案用戶</Dropdown.Header>

              <Dropdown.Divider />
              <Dropdown.Item
                as={Link}
                to={currentUser ? '/metabolic-plan' : ''}
                className={` ${pathname === '/metabolic-plan' ? 'nav-link' : ''}`}
                onClick={() => {
                  isLogin('/metabolic-plan')
                }}
              >
                <i className="fa-solid fa-location-crosshairs me-2"></i>
                代謝計畫
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
          {/* <NavLink
            to={currentUser ? '/metabolic-plan' : ''}
            className={` ${pathname === '/metabolic-plan' ? 'nav-link' : ''}`}
            onClick={() => {
              isLogin('/metabolic-plan')
            }}
          >
            <i className="fa-solid fa-location-crosshairs me-2"></i>
            代謝計畫
          </NavLink> */}
          <NavLink to="/aboutUs" className="nav-link">
            <i className="fa-solid fa-circle-info me-2"></i>
            關於我們
          </NavLink>
        </Nav>
        {/* ---------- Login ---------- */}
        {currentUser && (
          <Dropdown drop="end" className="user position-absolute">
            <Dropdown.Toggle size="lg" variant="" id="dropdown-basic">
              <i className="fa-solid fa-circle-user me-2"></i>
              <span
                style={{
                  maxWidth: '200px',
                  wordBreak: 'break-all',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {currentUser.name} {'  '}
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ fontSize: '20px' }}>
              {/* <Dropdown.Item as={Link} to="/settings">
                <i className="fa-solid fa-gear me-2"></i>
                設定
              </Dropdown.Item> */}
              <Dropdown.Item as={Link} to="/admin">
                <i className="fa-solid fa-home me-2"></i>
                進入後台
              </Dropdown.Item>
              <Dropdown.Item
                onClick={(e) => {
                  // setCurrentUser(null)
                  setLoginShow(false)
                  navigate('/')
                  handleLogout(e)
                }}
              >
                <i className="fa-solid fa-right-from-bracket me-2"></i>
                登出
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
        {/* {loginShow && ( */}
        <div className="user position-absolute">
          <Login
            currentUser={currentUser}
            setCurrentUser={setCurrentUser}
            loginShow={loginShow}
            setLoginShow={setLoginShow}
            redirectTo={redirectTo}
            setRedirectTo={setRedirectTo}
            sendDiscordNotification={sendDiscordNotification}
          />
        </div>
        {/* )} */}
      </div>
    </>
  )
}

export default HaNavbar
